import axios from 'axios'
import {logDOM} from "@testing-library/react";

axios.withCredentials = true

// create an axios instance
const service = axios.create({
    baseURL: process.env.REACT_APP_path, // url = base url + request url
    // baseURL: 'http://192.168.124.145:9011', // url = base url + request url
    // baseURL: '/api', // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        config.headers['websiteId'] = 43 // 更换网站要修改这里 以及router/index.js那里
        config.headers['langId'] = 4
        console.log('config', config)
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 200) {
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        return Promise.reject(error)
    }
)

export default service
